import { ParamsWithPagination } from '@/types/api';

import { FeaturedPeopleFilters } from '../types';

export const featuredPeopleQueryKeys = {
  all: ['featured-people'] as const,
  byId: (id: string) => [...featuredPeopleQueryKeys.all, { id }] as const,
  lists: () => [...featuredPeopleQueryKeys.all, 'list'] as const,
  list: (params?: ParamsWithPagination<FeaturedPeopleFilters>) =>
    [...featuredPeopleQueryKeys.lists(), params] as const,
  /**
   * Kept apart from `list`: the paged query caches an array of pages, the one-page callers
   * cache a single response. Sharing a key would hand one shape to the other.
   */
  infiniteLists: () => [...featuredPeopleQueryKeys.all, 'infinite-list'] as const,
  infiniteList: (params?: ParamsWithPagination<FeaturedPeopleFilters>) =>
    [...featuredPeopleQueryKeys.infiniteLists(), params] as const,
  /** Sorted, so every view resolving the same people shares one request. */
  selected: (ids: string[]) =>
    [...featuredPeopleQueryKeys.all, 'selected', [...ids].sort()] as const,
};
